import { render, staticRenderFns } from "./Create_customer.vue?vue&type=template&id=9b8bdae6&"
import script from "./Create_customer.vue?vue&type=script&lang=js&"
export * from "./Create_customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports